export enum OrderStatusEnum {
  IN_PROGRESS = 'in_progress',
  ACCEPTED = 'accepted',
  ON_HOLD = 'on_hold',
  PLANNED = 'planned',
  INVOICED = 'delivered',
  TERMINATION_REQUESTED = 'termination_requested',
  TERMINATED = 'terminated',
  DECLINED = 'declined',
}

export enum OrderStatusIdEnum {
  IN_PROGRESS = '18b97220-2aac-42b1-9a65-eb8091c3ff38',
  ACCEPTED = '7e8f2d37-d0f8-4d22-be58-be625e2d9b95',
  ON_HOLD = '80abf1d7-01d5-4a00-92f0-121f72eca0c9',
  PLANNED = 'a97b86c1-71ad-41ee-8a31-95646a03b8cc',
  INVOICED = '951967b8-f77a-40d6-9f9b-3b18ed92f841',
  TERMINATION_REQUESTED = '7794a170-7e58-49df-838e-94df59e4809d',
  TERMINATED = '7f1a2cab-b864-4e43-a3c4-cdad2327a20b',
  DECLINED = '3d3a9d37-9118-41fc-9a65-7e97bed9bf0e',
}
